import { KitLink, KitText } from '@omni/kit/components';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Includes required text ("This site is protected...") for hiding the badge.
 * See https://cloud.google.com/recaptcha/docs/faq#hiding-the-badge
 */

export default function RecaptchaDisclaimer({
  isEnterprise = true,
  center = true,
}: {
  isEnterprise?: boolean;
  center?: boolean;
}): ReactElement {
  const { t } = useTranslation();

  return (
    <>
      <KitText
        style={{
          fontSize: 14,
          lineHeight: 20,
          ...(center && { textAlign: 'center' }),
        }}
      >
        <Trans
          i18nKey='common:recaptchaDisclaimer'
          values={{
            enterprise: isEnterprise ? ` ${t('common:enterprise')}` : '',
          }}
          components={{
            privacyLink: (
              <KitLink
                href='https://policies.google.com/privacy'
                fontSize={14}
              />
            ),
            termsLink: (
              <KitLink href='https://policies.google.com/terms' fontSize={14} />
            ),
          }}
        />
      </KitText>
    </>
  );
}
